import React from "react";
import { Switch } from "react-router-dom";
import { connect } from "react-redux";
import PrivateRoute from "components/common/PrivateRoute";
import PlanogramMaintenance from "components/menu/master-files/planogram-maintenance/list";
import PlanogramTabs from "components/menu/master-files/planogram-maintenance/planogram-tabs";

const PlanogramMaintenanceRouter = props => (
    <div className="px-5">
        <Switch>
            <PrivateRoute
                exact
                path={`${props.match.url}/`}
                component={PlanogramMaintenance}
            />
            <PrivateRoute
                path={`${props.match.url}/:planogramId`}
                component={PlanogramTabs}
            />
        </Switch>
    </div>
);

export default connect()(PlanogramMaintenanceRouter);
